import React from 'react'
import style from './MakeHeader.module.css'

/**
 * HeaderButton
 * -------------------------------------------------
 * Reusable icon button + hover tooltip used across the header's
 * right-actions area (help, save, settings, sleep, ...).
 *
 * variant:
 *   "help"   -> help_button wrapper + iconBtnSize img (assembly/hex/save/connectivity)
 *   "action" -> header_button wrapper + userAccount_settingBtn img (settings/sleep)
 */
export default function HeaderButton({
    variant = 'action',
    src,
    onClick,
    alt,
    tooltip,
    imgStyle,
}) {
    const wrapperClass =
        variant === 'help' ? style.help_button : style.header_button
    const imgClass =
        variant === 'help' ? style.iconBtnSize : style.userAccount_settingBtn

    return (
        <div className={wrapperClass}>
            <img
                className={imgClass}
                src={src}
                onClick={onClick}
                alt={alt}
                style={imgStyle}
            />
            {tooltip && (
                <span className={style.tooltiptext}>
                    <p>{tooltip}</p>
                </span>
            )}
        </div>
    )
}
